import React from 'react';
import Link from '../../../ui/Link.component';
import InlineMessage from '../../../ui/panel/InlineMessage.component';

export function FedExPendingMessage() {
	return (
		<div className="banner-container">
			<InlineMessage
				type="information"
				header="Your FedEx connection request is under review."
				text="Approval typically takes up to 24 hours."
				actions={
					<Link
						href="https://help.stamps.com/hc/en-us/articles/43008363601435-FedEx-from-Stamps-com"
						target="_lank"
						rel="noopener noreferrer"
						dataqa="fedex-reseller-pending-banner-link"
						navIcon={true}
					>
						Learn more
					</Link>
				}
				dataqa="fedex-reseller-pending-banner"
			></InlineMessage>
		</div>
	);
}
